export interface InputOption {
	vmodel: string,
	display?: string,
	label?: string,
	message?: string,
	required?: boolean,
	disabled: boolean,
	sub?: boolean,
	icon?: string,
	max?: number,
	counter?: boolean,
	trigger: boolean,
	error: boolean,
	height?: number,
	clear: boolean,
	reset: boolean,
	showToolTip?: boolean,
	maxValue?: number,
	minDate?: string,
	checkEvenIfDisabled?: boolean
}

export enum InputMessage {
	ChampRequis = "Champ requis",
	EmailInvalid = "L'email est invalide",
	CodePostalInvalid = "Le code postal est invalide",
	PhoneInvalid = "Le numéro de téléphone est invalide",
	SecuInvalid = "Le numéro de sécurité social est invalide",
	DecimalInvalid = "Le format monétaire est invalide",
}

export interface KeyValue {
	key: string,
	value: string
}



// WEBPACK FOOTER //
// ./src/shared/models/Input.ts